import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-contracts';

const renewContractById = async (contractId) => {
  const method = 'POST';
  const url = `${USE_CASE_URL}/action/renew`;

  const body = {
    id: contractId
  };
  const json = await request({ method, url, body });
  return json;
};

export default renewContractById;
